import React from 'react';
import RulesBulkUpload from 'Components/RulesBulkUpload';
import { useTranslation } from 'react-i18next';
import { POSSIBLE_STATUS, useUploaderContext } from './context';
import { formatBytes } from '../GenericListFileUploader/sheetjs-helpers';

const Instructions = () => {
    const { listName, status, maxFileSize } = useUploaderContext();
    const { t } = useTranslation();
    if (status === POSSIBLE_STATUS.chunking || status === POSSIBLE_STATUS.chunkingComplete) return null;

    return (
        <>
            <RulesBulkUpload.Title
                title={t('singleListBulkUpload.title', { listName })}
                dataTestId='list-page-bulk-upload-title'
            />
            <RulesBulkUpload.UploadInstructions
                dataTestId='list-page-bulk-upload-instructions'
                instructions={
                    <>
                        {t('singleListBulkUpload.instructions')}{' '}
                        {t('singleListBulkUpload.fileSizeInstructions', {
                            // the size of the PCI list is determine by the BCATS component
                            // we might want to make that configurable but... we'll see.
                            fileSize: formatBytes(maxFileSize),
                            fileTypes: '.CSV'
                        })}
                    </>
                }
            />
        </>
    );
};

export default Instructions;
